import { Controller } from "stimulus"

export default class extends Controller {

  initialize() {
    // validations
    //this.editTeamMemberForm = this.editTeamMemberForm();
    this.addModalEventListener()
  }

  addModalEventListener() {
    let self = this;
    let editTeamMemberModal = document.getElementById('editTeamMemberModal')
    editTeamMemberModal.addEventListener('shown.bs.modal', function (event) {
      
      let button = event.relatedTarget
      let teamData = button.getAttribute('data-bs-edit-team-member')
      let data = JSON.parse(teamData);
      document.getElementById('editTeamMemberName').value = data.name
      document.getElementById('editTeamMemberEmail').value = data.email
      document.getElementById('editNotifySafeguard').checked = data.notify_safeguard
      document.getElementById('editCanAdmin').checked = data.can_admin_account
      console.log(data)
      document.getElementById('editTeamMemberForm').action = 'team/' + data.id.toString();
      
          // Focus on the first visible input field in the modal
      let inputs = editTeamMemberModal.querySelectorAll('input');
      for(let i = 0; i < inputs.length; i++) {
        if(inputs[i].type !== 'hidden' && window.getComputedStyle(inputs[i]).display !== 'none') {
          inputs[i].focus();
          break;
        }
      }
    })

  }


  submitContactForm() {
    document.getElementById("editContactSubmit").disabled = true;
    this.editContactForm.validate().then(function (status) {
      if (status == 'Valid') {
        document.getElementById("editContactForm").submit();
      } else {
        document.getElementById("editContactSubmit").disabled = false;
      }
    });
  }

  phoneOrEmailPresent() {
    return this.phoneTarget.value?.length > 0;
  }

  editContactForm() {
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('editContactForm'),
      {
        fields: {
          contactName: {
            selector: '[name="contact_form[name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Full name is required'
              },
              stringLength: {
                max: 255,
                message: 'Full name must be less than 255 characters'
              }
            }
          },
          contactPreferredName: {
            selector: '[name="contact_form[preferred_name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Preferred name is required'
              },
              stringLength: {
                max: 255,
                message: 'Preferred name must be less than 255 characters'
              }
            }
          },
          reference: {
            selector: '[name="contact_form[reference]"]',
            validators: {
              stringLength: {
                max: 255,
                message: 'Reference must be less than 255 characters'
              }
            }
          },
          phone: {
            selector: '[name="contact_form[phone]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Phone number is required'
              },
              checkValidNumber: {
                message: 'Please enter a valid phone number',
                callback: function (input) {
                  return input.value.length == 0 || isValidPhoneNumber(input.value, 'GB')
                }
              },
              emailOrPhonePresent: {
                message: 'Phone must be present if no email provided',
                callback: function () {
                  return self.phoneOrEmailPresent()
                }
              }
            }
          },
          secondaryPhone: {
            selector: '[name="contact_form[secondary_phone]"]',
            validators: {
              checkValidNumber: {
                message: 'Please enter a valid number',
                callback: function (input) {
                  return input.value.length == 0 || isValidPhoneNumber(input.value, 'GB')
                }
              }
            }
          },
          contactRoles: {
            selector: '[name="contact_form[contact_roles][]"]',
            validators: {
              choice: {
                min: 1,
                message: 'Please select at least one role for this contact'
              }
            }
          },
          notes: {
            selector: '[name="contact_form[notes]"]',
            validators: {
              stringLength: {
                max: 30000,
                message: 'Notes must be less than 30,000 characters'
              }
            }
          },
          emergency_contact_details: {
            selector: '[name="contact_form[emergency_contact_details]"]',
            validators: {
              stringLength: {
                max: 256,
                message: 'Emergency contact details must be less than 256 characters'
              }
            }
          }
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger(),
          bootstrap5: new Bootstrap5({
            rowSelector: '.g-5'
          }),
          alias: new FormValidation.plugins.Alias({
            checkValidNumber: 'callback',
            emailOrPhonePresent: 'callback'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
          trigger: new FormValidation.plugins.Trigger(
            {
              event: 'input',
              threshold: 1,
              delay: 1

            }
          ),
        },
      }
    )
  }

}